module.exports = reqwest;


//////////////////
// WEBPACK FOOTER
// external "reqwest"
// module id = 2
// module chunks = 0